import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/auth";
import { Link } from "react-router-dom";
import moment from "moment";
import { VerConfiguracion } from "./modalVerConfiguracion";
import { ConfigMina } from "./configuracionesDeModulos/modalConfigMinas";
import { ConfigProduccion } from "./configuracionesDeModulos/modalConfigProduc";
import { Config1x500 } from "./configuracionesDeModulos/modalConfig1x500";
import CargarCatdesdeEfiscal from "./presupuesto/modalCargarCatdesdeEfiscal";
import { Mensaje, MensajeSiNo } from "./mensajes";
import axios from "axios";
import CargarPucEfiscal from "./presupuesto/modalCargarPucdesdeEfiscal";
import { ReversarTransaccion } from "./ingresos/modalReversarTransaccion";
import { ResumenCaja } from "./modalResumenCaja";
import { ReimprimirRecibo } from "./ingresos/modalReimprimirRecibo";
import { ResumenRetenciones } from "./modalResumenRetenciones";
import { ResumenDeclaracionMina } from "./modalResumenDeclaracionMina";
import { MinaxClasificador } from "./modalMinaxClasificador";
import { ProduccionxClasificador } from "./modalProduccionxClasificador";
import { ResumenDeclaracionProduccion } from "./modalResumenDeclaracionProduccion";
import { ImprimirTimbresporEntes } from "./timbres/modalImprimirTimbresEntes";
import { ReporteInspecciones } from "./modalinspeccionesreporte";

function Sidebar(props) {
  moment.locale("es");

  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const statuspresup = JSON.parse(localStorage.getItem("statuspresup"));

  const { user, logout } = useContext(AuthContext);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const accconfigrentas = JSON.parse(localStorage.getItem("accconfigrentas"));
  const accrentasinm = JSON.parse(localStorage.getItem("accrentasinm"));
  const accpdfrentas = JSON.parse(localStorage.getItem("accpdfrentas"));

  const accconfigestadal = JSON.parse(localStorage.getItem("accconfigestadal"));
  const accestadal = JSON.parse(localStorage.getItem("accestadal"));
  const accpdfestadal = JSON.parse(localStorage.getItem("accpdfestadal"));

  const accsolvencia = JSON.parse(localStorage.getItem("accsolvencia"));
  const accconfigsolvencia = JSON.parse(
    localStorage.getItem("accconfigsolvencia")
  );
  const accpdfsolvencia = JSON.parse(localStorage.getItem("accpdfsolvencia"));

  const accimpproduccion = JSON.parse(localStorage.getItem("accimpproduccion"));
  const acctimbresfis = JSON.parse(localStorage.getItem("acctimbresfis"));
  const accpdftimbres = JSON.parse(localStorage.getItem("accpdftimbres"));
  const accconfigtimbres = JSON.parse(localStorage.getItem("accconfigtimbres"));
  const accconfigproducc = JSON.parse(localStorage.getItem("accconfigproducc"));
  const accpdfproducc = JSON.parse(localStorage.getItem("accpdfproducc"));
  const accimpminas = JSON.parse(localStorage.getItem("accimpminas"));
  const accconfigminas = JSON.parse(localStorage.getItem("accconfigminas"));
  const accimp1x500 = JSON.parse(localStorage.getItem("accimp1x500"));
  const accconfig1x500 = JSON.parse(localStorage.getItem("accconfig1x500"));
  const accpdf1x500 = JSON.parse(localStorage.getItem("accpdf1x500"));
  const accpdfminas = JSON.parse(localStorage.getItem("accpdfminas"));
  const accfiscal = JSON.parse(localStorage.getItem("accfiscal"));
  const accconfigfiscal = JSON.parse(localStorage.getItem("accconfigfiscal"));
  const accpdffiscal = JSON.parse(localStorage.getItem("accpdffiscal"));
  const accgestion = JSON.parse(localStorage.getItem("accgestion"));
  const accconfiggestion = JSON.parse(localStorage.getItem("accconfiggestion"));
  const accpdfgestion = JSON.parse(localStorage.getItem("accpdfgestion"));
  const accpresupuesto = JSON.parse(localStorage.getItem("accpresupuesto"));
  const accconfigpresu = JSON.parse(localStorage.getItem("accconfigpresu"));
  const accpdfpresu = JSON.parse(localStorage.getItem("accpdfpresu"));
  const acctimbreelectromod = JSON.parse(
    localStorage.getItem("acctimbreelectromod")
  );
  const accconfigtimbreelectro = JSON.parse(
    localStorage.getItem("accconfigtimbreelectro")
  );
  //
  const [usuario, setUsuario] = useState(
    JSON.parse(localStorage.getItem("login"))
  );
  const [tituloNav, setTituloNav] = useState("Panel de Control");
  const [verConfiguracion, setVerConfiguracion] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operaciontrans, setOperaciontrans] = useState(0);
  const [valorcp, setValorcp] = useState(0);
  const [operacionpu, setOperacionpu] = useState(0);
  const [operacioncat, setOperacioncat] = useState(0);
  const [activate, setActivate] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [permisos, setPermisos] = useState(
    JSON.parse(localStorage.getItem("permisos"))
  );
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [mostrar8, setMostrar8] = useState(false);
  const [mostrar9, setMostrar9] = useState(false);
  const [mostrar10, setMostrar10] = useState(false);
  const [mostrar11, setMostrar11] = useState(false);
  const [mostrar12, setMostrar12] = useState(false);
  const [mostrar13, setMostrar13] = useState(false);
  const [mostrarInspecciones, setMostrarInspecciones] = useState(false);
  const [tipoAgente, setTipoAgente] = useState(null);
  const [reporteGestionIngresos, setReporteGestionIngresos] = useState("");
  const [tituloGestionIngresos, setTituloGestionIngresos] = useState("");

  let el;
  let ele;
  const bloquear = (titulo) => (e) => {
    e.preventDefault();
    setTituloNav(titulo);
    props.onCambiar(titulo);
    if ((el = document.getElementById("wrapper"))) {
      el.classList.toggle("toggled");
      if ((ele = document.getElementById("menu-toggle"))) {
        ele.classList.toggle("bloquear");
      }
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/eliminarcatprogramatica/${operacioncat}`;
    let body;
    setActivate(true);

    body = {
      idefiscal: idefiscal,
      val: valorcp,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Registro Eliminado Correctamente",
            icono: "exito",
          });
          SeleccionarEfiscal();
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseSi = () => {
    if (operacioncat === 6) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacioncat === 7) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const SelecccionarEfiscal = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.statuscat !== 32) {
            setMostrar3(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La Categoria Programática ya fué Cargada",
              icono: "informacion",
            });
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelecccionarEfiscals = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.statuspuc !== 22) {
            setMostrar4(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Los Clasificadores Presupuestarios ya Fuerón Cargados",
              icono: "informacion",
            });
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const modalConfigMina = () => {
    if (!mostrar) {
      setMostrar(true);
    } else {
      setMostrar(false);
    }
  };

  const modalConfigProduc = () => {
    if (!mostrar1) {
      setMostrar1(true);
    } else {
      setMostrar1(false);
    }
  };

  const modalConfig1x500 = () => {
    if (!mostrar2) {
      setMostrar2(true);
    } else {
      setMostrar2(false);
    }
  };

  const verConfig = () => {
    if (!verConfiguracion) {
      setVerConfiguracion(true);
    } else {
      setVerConfiguracion(false);

      setPermisos(JSON.parse(localStorage.getItem("permisos")));

      //window.location.href = '/inicio'
    }
  };

  const gestionarEfiscarCat = (op, id) => (e) => {
    if (op === 1) {
      setOperacion(op);
      SelecccionarEfiscal(id);
    } else if (op === 2) {
      setOperacionpu(op);
      SelecccionarEfiscals(id);
    } else if (op === 3) {
      let msg = "";
      setOperacioncat(6);
      setValorcp(31);
      if (statuspresup === 1) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else {
        msg =
          "Las categorias no pueden ser eliminadas porque el presupuesto esta aprobado o cerrado";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: msg,
          icono: "informacion",
        });
      }
    } else if (op === 4) {
      let msg = "";
      setOperacioncat(7);
      setValorcp(11);
      if (statuspresup === 1) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      } else {
        msg =
          "El PUC no puede ser eliminado porque el presupuesto esta aprobado o cerrado";
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: msg,
          icono: "informacion",
        });
      }
    }
  };

  const gestionarTransaccion = (op, id) => (e) => {
    if (op === 2) {
      setOperaciontrans(op);
      setMostrar5(true);
    } else if (op === 3) {
      setOperaciontrans(op);
      setMostrar7(true);
    }
  };

  const gestionIngresosReporte = (reporte, titulo) => (e) => {
    setReporteGestionIngresos(reporte);
    setTituloGestionIngresos(titulo);
    setMostrar6(true);
  };

  const modalCargCat = () => {
    setMostrar3(false);
  };

  const modalCargPuc = () => {
    setMostrar4(false);
  };

  const modalReversarTransaccion = () => {
    setMostrar5(false);
  };

  const modalReimprimirRecibo = () => {
    setMostrar7(false);
  };

  const imprimirDeudaGeneralImpuesto = (cond, conf, tip) => (event) => {
    event.preventDefault();
    const condicion = "'" + cond + "'";
    const fecha = "'" + fechaSistema.substring(0, 10) + "'";
    const config = "'" + conf + "'";
    const tipo = tip;

    if (tip === "RET") {
      window.open(
        op.reportes + "reporte=DeudaGeneralRet",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      window.open(
        op.reportes +
          "reporte=DeudaGeneralImpuesto&CONDICION=" +
          condicion +
          "&FECHASISTEMA=" +
          fecha +
          "&CONFIG=" +
          config +
          "&TIPOIMPUESTO=" +
          tipo,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const imprimirListaAgente = (cond, sta, tip) => (event) => {
    event.preventDefault();
    window.open(
      op.reportes +
        "reporte=ListadoAgenteImpuesto&CONDICION=" +
        cond +
        "&STATUS=" +
        sta +
        "&TIPO=" +
        tip,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirListaClaseMinas = () => {
    window.open(
      op.reportes + "reporte=ListaClasificadorMina",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirListaClaseProduccion = () => {
    window.open(
      op.reportes + "reporte=ListaClasificadorProduccion",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirListaClasexAgentes = () => {
    window.open(
      op.reportes + "reporte=ClasificadorxAgentes",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const sidebar = user && (
    <div className="amanecergris" id="sidebar-wrapper">
      <div className="sidebar-heading text-center py-4 bluez-text fs-4 fw-bold text-uppercase border-bottom">
        <img
          className="img-fluid"
          src={"imagenes/" + op.logo}
          style={{ width: "100px" }}
          alt=""
        />
        <h5 className="m-0 text-second ">{moment(fechaSistema).format("L")}</h5>
      </div>
      <div className="list-group list-group-flush ">
        <div className="list-group list-group-flush">
          <Link
            to="/inicio"
            className="list-group-item list-group-item-action py-2 ripple active text-center"
          >
            <h3 className="H">S-TIMBRES</h3>
          </Link>
          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(0, 1) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(0, 1) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(0, 1) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-ticket-alt fa-fw me-3" />
              <span className=" fw-bold">Timbres Fiscales</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registro de Expendedores")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(0, 1) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link to="/expendedores" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-user-friends fa-fw me-1" />
                    Registro de Expendedores
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Registro Tipo Entes")}
                style={{
                  pointerEvents:
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/timbrefiscaltipoentes"
                  className={
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(1, 2) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-user-tag fa-fw me-1" />
                    Tipo Entes
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Registro de Entes")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(1, 2) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link to="/entes" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-users fa-fw me-1" />
                    Registro de Entes
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Registro Dependencias")}
                style={{
                  pointerEvents:
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/timbrefiscaldependencias"
                  className={
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(2, 3) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-object-ungroup fa-fw me-1" />
                    Dependencias
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Registro Tramites")}
                style={{
                  pointerEvents:
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/timbrefiscaltramites"
                  className={
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(3, 4) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Tramites
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Timbre Electronico")}
                style={{
                  pointerEvents:
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/timbrefiscalelectronico"
                  className={
                    acctimbreelectromod &&
                    acctimbreelectromod.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    Timbre Electronico
                  </span>
                </Link>
              </li>
              {/*               <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Timbre Electronico")}
                    style={{
                      pointerEvents:
                        accconfigtimbreelectro &&
                        accconfigtimbreelectro.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisostimbreelectronico"
                      className={
                        accconfigtimbreelectro &&
                        accconfigtimbreelectro.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                </ul>
              </li> */}
              <li
                onClick={bloquear("Generación de Timbres Fiscales")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(2, 3) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link
                  to="/generarPlanilla/TF"
                  className="dropdown-item ripple "
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    Generación de Timbres Fiscales
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Asignación de Timbres Fiscales")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(3, 4) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link to="/asgtimbres/TF" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Asignación de Timbres Fiscales
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Desasignación de Timbres Fiscales")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(4, 5) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(4, 5) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link to="/desasgtimbres/TF" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Desasignación de Timbres Fiscales
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Anulacion de Timbres Fiscales")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(5, 6) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(5, 6) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link
                  to="/anulartimbrefiscal/TF"
                  className="dropdown-item ripple "
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Anulacion de Timbres Fiscales
                  </span>
                </Link>
              </li>

              <li
                onClick={bloquear("Venta de Timbres Fiscales")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(6, 7) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(6, 7) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link to="/ventatimbres/TF" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Venta de Timbres Fiscales
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Generar Deuda TF")}
                style={{
                  pointerEvents:
                    acctimbresfis && acctimbresfis.substring(7, 8) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    acctimbresfis && acctimbresfis.substring(7, 8) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link
                  to="/generarDeudaPlanilla/TF"
                  className="dropdown-item ripple "
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    Generar Deuda TF
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Estados de Cuenta Expendedores")}
                style={{
                  pointerEvents:
                    accimpproduccion && accimpproduccion.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    accimpproduccion && accimpproduccion.substring(3, 4) === "0"
                      ? " "
                      : "rgba(144, 143, 142, 0.76)",
                }}
              >
                <Link
                  to="/expendedorestadocuenta"
                  className="dropdown-item ripple "
                >
                  <span>
                    <i className="fas fa-book-reader fa-fw me-1" />
                    Estado de Cuenta
                  </span>
                </Link>
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Timbres")}
                    style={{
                      pointerEvents:
                        accconfigtimbres &&
                        accconfigtimbres.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigtimbres &&
                        accconfigtimbres.substring(0, 1) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link
                      to="/permisostimbres"
                      className="dropdown-item ripple "
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={bloquear("Configuración del Modulo Timbres")}
                    style={{
                      pointerEvents:
                        accconfigtimbres &&
                        accconfigtimbres.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigtimbres &&
                        accconfigtimbres.substring(1, 2) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Configuración del Modulo
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={bloquear("Fecha de Vencimiento")}
                    style={{
                      pointerEvents:
                        accconfigtimbres &&
                        accconfigtimbres.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigtimbres &&
                        accconfigtimbres.substring(2, 3) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Fecha de Vencimiento
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras mt-222m">
                  <li
                    onClick={imprimirListaAgente(
                      "idtipoagente = 4 and status=51",
                      "status",
                      "EXPENDEDORES"
                    )}
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(0, 1) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Expendedores Registrados (ACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaAgente(
                      "idtipoagente = 4 and status<>51",
                      "status",
                      "EXPENDEDORES"
                    )}
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(0, 1) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Expendedores Registrados (INACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaAgente(
                      "idtipoagente = 1 and status=51",
                      "status",
                      "ENTES"
                    )}
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(1, 2) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Entes Receptores Registrados (ACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaAgente(
                      "idtipoagente = 1 and status<>51",
                      "status",
                      "ENTES"
                    )}
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(1, 2) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Entes Receptores Registrados (INACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(2, 3) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Impresión de Licencia de Expendedores
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(3, 4) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Impresión de P/A. de Entes
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(4, 5) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(4, 5) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Timbres Asignados/Expendedor
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(5, 6) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(5, 6) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Timbres Vendidos/Expendedor
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(6, 7) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(6, 7) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Timbres Anulados/Expendedor
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setMostrar13(true)}
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(7, 8) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(7, 8) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Timbres por Entes
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdftimbres && accpdftimbres.substring(8, 9) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accpdftimbres && accpdftimbres.substring(8, 9) === "0"
                          ? " "
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Stock de Timbres
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(1, 2) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(1, 2) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(1, 2) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-cash-register fa-fw me-3" />
              <span className=" fw-bold">Impuesto/Producción</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registro de Contribuyentes por Producción")}
                style={{
                  pointerEvents:
                    accimpproduccion && accimpproduccion.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    accimpproduccion && accimpproduccion.substring(0, 1) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "",
                }}
              >
                <Link to="/producccion" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-users fa-fw me-1" />
                    Registro de Contribuyentes por Producción
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear(
                  "Declaraciones por Contribuyentes Producción"
                )}
                style={{
                  pointerEvents:
                    accimpproduccion && accimpproduccion.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    accimpproduccion && accimpproduccion.substring(1, 2) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "",
                }}
              >
                <Link
                  to="/declaracionProduccion"
                  className="dropdown-item ripple "
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Declaraciones por Contribuyentes Producción
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Clasificador Impuesto Producción")}
                style={{
                  pointerEvents:
                    accimpproduccion && accimpproduccion.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    accimpproduccion && accimpproduccion.substring(2, 3) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "",
                }}
              >
                <Link to="/producclass" className="dropdown-item ripple ">
                  <span>
                    <i className="fas fa-pen-square fa-fw me-1" />
                    Clasificador Impuesto Producción
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Estados de Cuenta Producción")}
                style={{
                  pointerEvents:
                    accimpproduccion && accimpproduccion.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    accimpproduccion && accimpproduccion.substring(3, 4) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "",
                }}
              >
                <Link
                  to="/producestadocuenta"
                  className="dropdown-item ripple "
                >
                  <span>
                    <i className="fas fa-book-reader fa-fw me-1" />
                    Estado de Cuenta
                  </span>
                </Link>
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Producción")}
                    style={{
                      pointerEvents:
                        accconfigproducc &&
                        accconfigproducc.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigproducc &&
                        accconfigproducc.substring(0, 1) === "0"
                          ? "none"
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link
                      to="permisosproduccion"
                      className="dropdown-item ripple "
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={modalConfigProduc}
                    style={{
                      pointerEvents:
                        accconfigproducc &&
                        accconfigproducc.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigproducc &&
                        accconfigproducc.substring(1, 2) === "0"
                          ? "none"
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        Configuración del Modulo
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={bloquear("Fechas de Vencimiento Producción")}
                    style={{
                      pointerEvents:
                        accconfigproducc &&
                        accconfigproducc.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigproducc &&
                        accconfigproducc.substring(2, 3) === "0"
                          ? "none"
                          : "rgba(144, 143, 142, 0.76)",
                    }}
                  >
                    <Link to="/fechavencpro" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-calendar-check fa-fw me-1" />
                        Fecha de Vencimiento
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={imprimirListaAgente(
                      "produccion = true and statusproduccion = 51",
                      "statusproduccion",
                      "IMPUESTO PRODUCCION"
                    )}
                    style={{
                      pointerEvents:
                        accpdfproducc && accpdfproducc.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfproducc && accpdfproducc.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Contribuyentes Registrados (ACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaAgente(
                      "produccion = true and statusproduccion<>51",
                      "statusproduccion",
                      "IMPUESTO PRODUCCION"
                    )}
                    style={{
                      pointerEvents:
                        accpdfproducc && accpdfproducc.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfproducc && accpdfproducc.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Contribuyentes Registrados (INACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setMostrar11(true)}
                    style={{
                      pointerEvents:
                        accpdfproducc && accpdfproducc.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfproducc && accpdfproducc.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Contribuyentes por Rubro
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaClaseProduccion}
                    style={{
                      pointerEvents:
                        accpdfproducc && accpdfproducc.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfproducc && accpdfproducc.substring(3, 4) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Clasificador/Producción
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setMostrar12(true)}
                    style={{
                      pointerEvents:
                        accpdfproducc && accpdfproducc.substring(4, 5) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfproducc && accpdfproducc.substring(4, 5) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen de Declaración
                      </span>
                    </Link>
                  </li>

                  <li
                    onClick={imprimirDeudaGeneralImpuesto(
                      "(tipodeuda = 2 or tipodeuda = 22 or tipodeuda = 222) and D.status = 0",
                      "configproduccion",
                      "IMPUESTO PRODUCCION"
                    )}
                    style={{
                      pointerEvents:
                        accpdfproducc && accpdfproducc.substring(5, 6) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfproducc && accpdfproducc.substring(5, 6) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Deuda Geneneral Produccion
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(2, 3) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(2, 3) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(2, 3) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-cash-register fa-fw me-3" />
              <span className=" fw-bold">Impuesto de Minas</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registro de Contribuyentes por Minas")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/minas"
                  className={
                    accimpminas && accimpminas.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-users fa-fw me-1" />
                    Registro de Contribuyentes por Minas
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Declaraciones Contribuyentes Minas")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/declaracionMinas"
                  className={
                    accimpminas && accimpminas.substring(1, 2) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Declaraciones Contribuyentes Minas
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Clasificador del Impuesto Minas")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/minaclass"
                  className={
                    accimpminas && accimpminas.substring(2, 3) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-pen-square fa-fw me-1" />
                    Clasificador del Impuesto Minas
                  </span>
                </Link>
              </li>

              <li
                onClick={bloquear("Estados de Cuenta Minas")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(4, 5) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/minasestadodecuenta"
                  className={
                    accimpminas && accimpminas.substring(4, 5) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-book-reader fa-fw me-1" />
                    Estado de Cuenta
                  </span>
                </Link>
              </li>

              <li
                onClick={bloquear("Actualizar Deuda Minas")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(5, 6) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/actualizardeudaminas"
                  className={
                    accimpminas && accimpminas.substring(5, 6) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-sync fa-fw me-1" />
                    Actualizar Deuda
                  </span>
                </Link>
              </li>

              <li
                onClick={bloquear("Guia De Movilizacion")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/guiamovilizacion"
                  className={
                    accimpminas && accimpminas.substring(3, 4) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    Guia De Movilización
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Solicitud de Guias")}
                style={{
                  pointerEvents:
                    accimpminas && accimpminas.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/solicitudguia"
                  className={
                    accimpminas && accimpminas.substring(3, 4) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    Solicitud de Guia
                  </span>
                </Link>
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Minas")}
                    style={{
                      pointerEvents:
                        accconfigminas && accconfigminas.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigminas && accconfigminas.substring(0, 1) === "0"
                          ? "rgba(144, 143, 142, 0.76)"
                          : "",
                    }}
                  >
                    <Link
                      to="/permisosminas"
                      className={
                        accconfigminas && accconfigminas.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={modalConfigMina}
                    style={{
                      pointerEvents:
                        accconfigminas && accconfigminas.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigminas && accconfigminas.substring(1, 2) === "0"
                          ? "rgba(144, 143, 142, 0.76)"
                          : "",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accconfigminas && accconfigminas.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        Configuración del Modulo
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={bloquear("Fechas de Vencimiento Minas")}
                    style={{
                      pointerEvents:
                        accconfigminas && accconfigminas.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        accconfigminas && accconfigminas.substring(2, 3) === "0"
                          ? "rgba(144, 143, 142, 0.76)"
                          : "",
                    }}
                  >
                    <Link
                      to="/fechavenc"
                      className={
                        accconfigminas && accconfigminas.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-calendar-check fa-fw me-1" />
                        Fecha de Vencimiento
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={imprimirListaAgente(
                      "mina = true and statusmina=51",
                      "statusmina",
                      "IMPUESTO MINA"
                    )}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Contribuyentes Registrados (ACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaAgente(
                      "mina = true and statusmina<>51",
                      "statusmina",
                      "IMPUESTO MINA"
                    )}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Contribuyentes Registrados (INACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setMostrar10(true)}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Contribuyentes por Rubro
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setMostrar9(true)}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen de Declaraciones
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaClaseMinas}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(3, 4) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Clasificador de Minas
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaClasexAgentes}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(3, 4) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Clasificador de Minas x Agentes
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirDeudaGeneralImpuesto(
                      "(tipodeuda = 1 or tipodeuda=11 or tipodeuda=111) and D.status = 0",
                      "configminas",
                      "IMPUESTO MINA"
                    )}
                    style={{
                      pointerEvents:
                        accpdfminas && accpdfminas.substring(5, 6) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfminas && accpdfminas.substring(5, 6) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Deuda Geneneral Mina
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(3, 4) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(3, 4) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(3, 4) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-cash-register fa-fw me-3" />
              <span className=" fw-bold">Impuesto 1x1000</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registro de Agentes/Retención")}
                style={{
                  pointerEvents:
                    accimp1x500 && accimp1x500.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/1x500"
                  className={
                    accimp1x500 && accimp1x500.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-users fa-fw me-1" />
                    Registro de Agentes/Retención
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Retención 1x1000")}
                style={{
                  pointerEvents:
                    accimp1x500 && accimp1x500.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/reten1x500"
                  className={
                    accimp1x500 && accimp1x500.substring(1, 2) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Retención 1x1000
                  </span>
                </Link>
              </li>

              <li
                onClick={bloquear("Estados de Cuenta 1x500")}
                style={{
                  pointerEvents:
                    accimp1x500 && accimp1x500.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/stadocuenta1x500"
                  className={
                    accimp1x500 && accimp1x500.substring(2, 3) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-book-reader fa-fw me-1" />
                    Estado de Cuenta
                  </span>
                </Link>
              </li>

              <li
                onClick={bloquear("Actualizar Deuda 1X1000")}
                style={{
                  pointerEvents:
                    accimp1x500 && accimp1x500.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/actualizardeuda1x1000"
                  className={
                    accimp1x500 && accimp1x500.substring(3, 4) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-sync fa-fw me-1" />
                    Actualizar Deuda
                  </span>
                </Link>
              </li>

              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios 1x500")}
                    style={{
                      pointerEvents:
                        accconfig1x500 && accconfig1x500.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisos1x500"
                      className={
                        accconfig1x500 && accconfig1x500.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={modalConfig1x500}
                    style={{
                      pointerEvents:
                        accconfig1x500 && accconfig1x500.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accconfig1x500 && accconfig1x500.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        Configuración del Modulo
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={bloquear("Fechas de Vencimiento 1x500")}
                    style={{
                      pointerEvents:
                        accconfig1x500 && accconfig1x500.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/fechareten"
                      className={
                        accconfig1x500 && accconfig1x500.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Fecha de Vencimiento
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={imprimirListaAgente(
                      "impuesto1x500 = true and status1x500=51",
                      "status1x500",
                      "IMPUESTO 1X500"
                    )}
                    style={{
                      pointerEvents:
                        accpdf1x500 && accpdf1x500.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdf1x500 && accpdf1x500.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Agentes Registrados (ACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirListaAgente(
                      "impuesto1x500 = true and status1x500<>51",
                      "status1x500",
                      "IMPUESTO 1X500"
                    )}
                    style={{
                      pointerEvents:
                        accpdf1x500 && accpdf1x500.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdf1x500 && accpdf1x500.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Agentes Registrados (INACTIVOS)
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setMostrar8(true)}
                    style={{
                      pointerEvents:
                        accpdf1x500 && accpdf1x500.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdf1x500 && accpdf1x500.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen Retenciones 1x1000
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={imprimirDeudaGeneralImpuesto(
                      "(tipodeuda = 3 or tipodeuda=33 or tipodeuda=33) and D.status = 0",
                      "config1x500",
                      "IMPUESTO 1X500"
                    )}
                    style={{
                      pointerEvents:
                        accpdf1x500 && accpdf1x500.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdf1x500 && accpdf1x500.substring(3, 4) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Deuda Geneneral 1x1000
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(8, 9) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(8, 9) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(8, 9) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-city fa-fw me-3" />
              <span className=" fw-bold">Rentas Inmobiliarias</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registros de Inmuebles")}
                style={{
                  pointerEvents:
                    accrentasinm && accrentasinm.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/inmmuebles"
                  className={
                    accrentasinm && accrentasinm.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-pen-square fa-fw me-1" />
                    Registro de Inmuebles
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Registro de Rentas Inmobiliarias")}
                style={{
                  pointerEvents:
                    accrentasinm && accrentasinm.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/inmmorentas"
                  className={
                    accrentasinm && accrentasinm.substring(1, 2) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-hotel fa-fw me-1" />
                    Registro de Renta Inmobiliaria
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Estados de Cuenta de Rentas Inmobiliarias")}
                style={{
                  pointerEvents:
                    accrentasinm && accrentasinm.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/estadoinmu"
                  className={
                    accrentasinm && accrentasinm.substring(2, 3) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-book-reader fa-fw me-1" />
                    Estado de Cuenta
                  </span>
                </Link>
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Rentas Inmobiliarias")}
                    style={{
                      pointerEvents:
                        accconfigrentas &&
                        accconfigrentas.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisosrentas"
                      className={
                        accconfigrentas &&
                        accconfigrentas.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={imprimirDeudaGeneralImpuesto(
                      "(tipodeuda = 17) and D.status = 0",
                      "configrentas",
                      "IMPUESTO RENTAS INMOBILIARIAS"
                    )}
                    style={{
                      pointerEvents:
                        accpdfrentas && accpdfrentas.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfrentas && accpdfrentas.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Deuda Geneneral Rentas
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(9, 10) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(9, 10) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(9, 10) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-city fa-fw me-3" />
              <span className=" fw-bold">Reg Estadal Tributario</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registro Estadal Tributario")}
                style={{
                  pointerEvents:
                    accestadal && accestadal.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/registroedotributario"
                  className={
                    accestadal && accestadal.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-hotel fa-fw me-1" />
                    Registro Estadal Tributario
                  </span>
                </Link>
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("")}
                    style={{
                      pointerEvents:
                        accconfigestadal &&
                        accconfigestadal.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisosrestadal"
                      className={
                        accconfigestadal &&
                        accconfigestadal.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={imprimirDeudaGeneralImpuesto("", "", "RET")}
                    style={{
                      pointerEvents:
                        accpdfestadal && accpdfestadal.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfestadal && accpdfestadal.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Deuda Geneneral RET
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          {/* 
          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(11, 12) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(11, 12) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(11, 12) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-digital-tachograph fa-fw me-3" />
              <span className=" fw-bold">Timbre Electronico</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            ></ul>
          </div>
 */}
          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(10, 11) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(10, 11) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(10, 11) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-chalkboard-teacher fa-fw me-3" />
              <span className=" fw-bold">Solicitud Solvencia</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Solicitud Solvencia")}
                style={{
                  pointerEvents:
                    accsolvencia && accsolvencia.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/solvencia"
                  className={
                    accsolvencia && accsolvencia.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-file-alt fa-fw me-1" />
                    Solicitud Solvencia
                  </span>
                </Link>
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("")}
                    style={{
                      pointerEvents:
                        accconfigsolvencia &&
                        accconfigsolvencia.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisossolvencia"
                      className={
                        accconfigsolvencia &&
                        accconfigsolvencia.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={imprimirDeudaGeneralImpuesto("", "", "RET")}
                    style={{
                      pointerEvents:
                        accpdfsolvencia &&
                        accpdfsolvencia.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfsolvencia &&
                        accpdfsolvencia.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        ------
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(4, 5) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(4, 5) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(4, 5) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-user-secret fa-fw me-3" />
              <span className=" fw-bold">Fiscalización</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Registro de Fiscales")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/fiscales"
                  className={
                    accfiscal && accfiscal.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-users fa-fw me-1" />
                    Registro de Fiscales
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Apertura de Procedimiento Fiscal")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/aperturaprocedimiento"
                  className={
                    accfiscal && accfiscal.substring(1, 2) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-external-link-square-alt fa-fw me-1" />
                    Apertura de Procedimiento
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Clasificador de Multas")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/clasificadormultas"
                  className={
                    accfiscal && accfiscal.substring(2, 3) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Clasificador de Multas
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Asignación de Multas")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/asignarmulta"
                  className={
                    accfiscal && accfiscal.substring(3, 4) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Asignación de Multas
                  </span>
                </Link>
              </li>
              {/* revisar permisos */}
              <li
                onClick={bloquear("Clasificador de Tasas")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(4, 5) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/clasificadortasas"
                  className={
                    accfiscal && accfiscal.substring(4, 5) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Clasificador de Tasas
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Asignación de Tasas")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(5, 6) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/asignartasa"
                  className={
                    accfiscal && accfiscal.substring(5, 6) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                    Asignación de Tasas
                  </span>
                </Link>
              </li>
              <li
                onClick={bloquear("Inspecciones")}
                style={{
                  pointerEvents:
                    accfiscal && accfiscal.substring(6, 7) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/inspeccion"
                  className={
                    accfiscal && accfiscal.substring(6, 7) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-external-link-square-alt fa-fw me-1" />
                    Inspecciones
                  </span>
                </Link>
              </li>
              {/* ************** */}
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Fiscales")}
                    style={{
                      pointerEvents:
                        accconfigfiscal &&
                        accconfigfiscal.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisosfiscal"
                      className={
                        accconfigfiscal &&
                        accconfigfiscal.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accconfigfiscal &&
                        accconfigfiscal.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accconfigfiscal &&
                        accconfigfiscal.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />#
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accconfigfiscal &&
                        accconfigfiscal.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accconfigfiscal &&
                        accconfigfiscal.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Fecha de Vencimiento
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras mt-140m">
                  <li
                    style={{
                      pointerEvents:
                        accpdffiscal && accpdffiscal.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdffiscal && accpdffiscal.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Procedimientos por Periodo
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdffiscal && accpdffiscal.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdffiscal && accpdffiscal.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen de Declaración Imp/Producción
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdffiscal && accpdffiscal.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdffiscal && accpdffiscal.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen de Declaración Imp/1x500
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdffiscal && accpdffiscal.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdffiscal && accpdffiscal.substring(3, 4) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Declaraciones por Periodo
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdffiscal && accpdffiscal.substring(4, 5) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdffiscal && accpdffiscal.substring(4, 5) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Clasificador de Multas
                      </span>
                    </Link>
                  </li>
                  <li
                  onClick={() => setMostrarInspecciones(true)}
                    style={{
                      pointerEvents:
                        accpdffiscal && accpdffiscal.substring(5, 6) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdffiscal && accpdffiscal.substring(5, 6) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen Inspecciones
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-ruble-sign fa-fw me-3" />
              <span className=" fw-bold">Gestión de Ingresos</span>
            </a>
            <ul
              className="dropdown-menu sombras"
              aria-labelledby="dropdownMenuButton"
            >
              <li
                onClick={bloquear("Caja")}
                style={{
                  pointerEvents:
                    accgestion && accgestion.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/cajaingresos"
                  className={
                    accgestion && accgestion.substring(0, 1) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-ruble-sign fa-fw me-1" />
                    Ingresos Diarios
                  </span>
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li
                onClick={bloquear("Verificación de Pagos")}
                style={{
                  pointerEvents:
                    accgestion && accgestion.substring(4, 5) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/verificarpago"
                  className={
                    accgestion && accgestion.substring(4, 5) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-check-square fa-fw me-1" />
                    Verificar Pagos
                  </span>
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li
                onClick={bloquear("Bancos")}
                style={{
                  pointerEvents:
                    accgestion && accgestion.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/bancos"
                  className={
                    accgestion && accgestion.substring(1, 2) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-university fa-fw me-1" />
                    Bancos
                  </span>
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li
                onClick={bloquear("Cuentas Bancarias")}
                style={{
                  pointerEvents:
                    accgestion && accgestion.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <Link
                  to="/cuentasbancarias"
                  className={
                    accgestion && accgestion.substring(2, 3) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                >
                  <span>
                    <i className="fas fa-ruble-sign fa-fw me-1" />
                    Cuentas Bancarias
                  </span>
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li
                style={{
                  pointerEvents:
                    accgestion && accgestion.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                }}
              >
                <a
                  className={
                    accgestion && accgestion.substring(3, 4) === "0"
                      ? "dropdown-item ripple color"
                      : "dropdown-item ripple "
                  }
                  href="#"
                >
                  <i className="fas fa-user-tie fa-fw me-1" />
                  Supervisor »
                </a>
                <ul className="dropdown-menu sombras dropdown-submenu sombras mt-110m">
                  <li onClick={gestionarTransaccion(2)}>
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-undo fa-fw me-1" />
                        Reversar Transacción
                      </span>
                    </Link>
                  </li>
                  <li onClick={gestionarTransaccion(3)}>
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-undo fa-fw me-1" />
                        Reimprimir Recibo
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-door-closed fa-fw me-1" />
                        Cerrar Caja
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-door-open fa-fw me-1" />
                        Abrir Caja
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-th-list fa-fw me-1" />
                        Transacciones Reversadas
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item ripple ">
                      <span>
                        <i className="fas fa-th-list fa-fw me-1" />
                        Timbres Asignados/Expendedor
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Ingresos Diarios")}
                    style={{
                      pointerEvents:
                        accconfiggestion &&
                        accconfiggestion.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisosgestion"
                      className={
                        accconfiggestion &&
                        accconfiggestion.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu sombras dropdown-submenu sombras mt-110m">
                  <li
                    className="dropdown-item ripple "
                    onClick={gestionIngresosReporte(
                      "resumenCaja",
                      "Resumen de Caja"
                    )}
                  >
                    <span>
                      <i className="far fa-file-pdf fa-fw me-1" />
                      Resumen de Caja
                    </span>
                  </li>
                  <li
                    className="dropdown-item ripple "
                    onClick={gestionIngresosReporte(
                      "resumenTransacciones",
                      "Transacciones Diarias"
                    )}
                  >
                    <span>
                      <i className="far fa-file-pdf fa-fw me-1" />
                      Transacciones Diarias
                    </span>
                  </li>
                  <li
                    className="dropdown-item ripple "
                    onClick={gestionIngresosReporte(
                      "resumenTransaccionesDetalladas",
                      "Transacciones Diarias Detalladas"
                    )}
                  >
                    <span>
                      <i className="far fa-file-pdf fa-fw me-1" />
                      Transacciones Diarias Detalladas
                    </span>
                  </li>
                  <li
                    className="dropdown-item ripple "
                    onClick={gestionIngresosReporte(
                      "resumenCajaBanco",
                      "Resumen de Caja por Banco"
                    )}
                  >
                    <span>
                      <i className="far fa-file-pdf fa-fw me-1" />
                      Resumen de Caja por Banco
                    </span>
                  </li>
                  <li
                    className="dropdown-item ripple "
                    onClick={gestionIngresosReporte(
                      "resumenTransaccionesReversadas",
                      "Transacciones Reversadas"
                    )}
                  >
                    <span>
                      <i className="far fa-file-pdf fa-fw me-1" />
                      Transacciones Reversadas
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="dropdown dropend ">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple "
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
              style={{
                pointerEvents:
                  permisos && permisos.substring(6, 7) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(6, 7) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(6, 7) === "0"
                    ? "transparent"
                    : "transparent",
              }}
            >
              <i className="fas fa-file-signature fa-fw me-3" />
              <span className=" fw-bold">Presupuesto</span>
            </a>
            <ul
              className="dropdown-menu sombras "
              aria-labelledby="dropdownMenuButton"
            >
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                  Formulación Presupuestaria »
                </a>
                <ul className="dropdown-menu sombras dropdown-submenu sombras mt-220m">
                  <li
                    onClick={bloquear("Ejercicio Fiscal")}
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/ejerfiscal"
                      className={
                        accpresupuesto && accpresupuesto.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-tags fa-fw me-1" />
                        Ejercicio Fiscal
                      </span>
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <a
                      className={
                        accpresupuesto && accpresupuesto.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                      href="#"
                    >
                      <i className="far fa-copy fa-fw me-1" />
                      Categorias Programaticas »
                    </a>
                    <ul className="dropdown-menu sombras dropdown-submenu sombras">
                      <li onClick={gestionarEfiscarCat(1, idefiscal)}>
                        <Link to="#" className="dropdown-item ripple ">
                          <span>
                            <i className="fas fa-exchange-alt fa-fw me-1" />
                            Cargar desde un Ejercicio Fiscal
                          </span>
                        </Link>
                      </li>
                      <li
                        onClick={bloquear(
                          "Actualizar Categorias Programaticas"
                        )}
                      >
                        <Link
                          to="/categoriaprogramatica"
                          className="dropdown-item ripple "
                        >
                          <span>
                            <i className="fas fa-redo-alt fa-fw me-1" />
                            Actualizar
                          </span>
                        </Link>
                      </li>
                      <li onClick={gestionarEfiscarCat(3, idefiscal)}>
                        <Link to="#" className="dropdown-item ripple ">
                          <span>
                            <i className="fa fa-trash fa-fw me-1" />
                            Eliminar Categorias Programaticas
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <a
                      className={
                        accpresupuesto && accpresupuesto.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                      href="#"
                    >
                      <i className="fas fa-list-alt fa-fw me-1" />
                      Clasificador Presupuestario »
                    </a>
                    <ul className="dropdown-menu sombras dropdown-submenu sombras">
                      <li onClick={gestionarEfiscarCat(2, idefiscal)}>
                        <Link to="#" className="dropdown-item ripple ">
                          <span>
                            <i className="fas fa-exchange-alt fa-fw me-1" />
                            Cargar desde Ejercicio Fiscal
                          </span>
                        </Link>
                      </li>
                      <li
                        onClick={bloquear(
                          "Actualizar Clasificador Presupuestario"
                        )}
                      >
                        <Link
                          to="/classpresupuestaria"
                          className="dropdown-item ripple "
                        >
                          <span>
                            <i className="fas fa-redo-alt fa-fw me-1" />
                            Actualizar
                          </span>
                        </Link>
                      </li>
                      <li onClick={gestionarEfiscarCat(4, idefiscal)}>
                        <Link to="#" className="dropdown-item ripple ">
                          <span>
                            <i className="fa fa-trash fa-fw me-1" />
                            Eliminar Clasificador Presupuestario
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <a
                      className={
                        accpresupuesto && accpresupuesto.substring(3, 4) === "0"
                          ? "dropdown-item ripple lugar"
                          : "dropdown-item ripple "
                      }
                      href="#"
                    >
                      <i className="fas fa-external-link-alt fa-fw me-1" />
                      Formular Presupuesto »
                    </a>
                    <ul className="dropdown-menu sombras dropdown-submenu sombras">
                      <li>
                        <a className="dropdown-item ripple " href="#">
                          <i className="fas fa-share fa-fw me-1" />
                          Cargar Presupuesto »
                        </a>
                        <ul className="dropdown-menu sombras dropdown-submenu sombras">
                          <li>
                            <Link to="#" className="dropdown-item ripple ">
                              <span>
                                <i className="fas fa-exchange-alt fa-fw me-1" />
                                Cargar desde Otros
                              </span>
                            </Link>
                          </li>
                          <li>
                            <Link to="#" className="dropdown-item ripple ">
                              <span>
                                <i className="fas fa-sort-numeric-down-alt fa-fw me-1" />
                                Cargar por Promedios
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      <li onClick={bloquear("Gestión de Presupuesto")}>
                        <Link
                          to="/crearpresu"
                          className="dropdown-item ripple "
                        >
                          <span>
                            <i className="fas fa-plus-square fa-fw me-1" />
                            Crear Presupuesto
                          </span>
                        </Link>
                      </li>
                      {/* <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item ripple ">
                                                <span><i className="fas fa-vector-square fa-fw me-1" />Cuadro de Obras</span>
                                            </Link>
                                        </li> */}
                      <li>
                        <Link to="#" className="dropdown-item ripple ">
                          <span>
                            <i className="fa fa-trash fa-fw me-1" />
                            Eliminar Presupuesto
                          </span>
                        </Link>
                      </li>
                      {/* <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item ripple ">
                                                <span><i className="fas fa-share-alt fa-fw me-1" />Relación de Cargos</span>
                                            </Link>
                                        </li> */}
                      {/* <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item ripple ">
                                                <span><i className="fas fa-share-alt fa-fw me-1" />Relación de Activos</span>
                                            </Link>
                                        </li> */}
                    </ul>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(4, 5) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpresupuesto && accpresupuesto.substring(4, 5) === "0"
                          ? "dropdown-item ripple color "
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-check-circle fa-fw me-1" />
                        Aprobar Presupuesto
                      </span>
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(5, 6) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpresupuesto && accpresupuesto.substring(5, 6) === "0"
                          ? "dropdown-item ripple color "
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-calendar-times fa-fw me-1" />
                        Cerrar Mes Presupuestario
                      </span>
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpresupuesto && accpresupuesto.substring(6, 7) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpresupuesto && accpresupuesto.substring(6, 7) === "0"
                          ? "dropdown-item ripple color "
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-calendar-check fa-fw me-1" />
                        Abrir Mes Presupuestario
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <span>
                    <i className="fas fa-cog fa-fw me-1" />
                    Configuración »
                  </span>
                </a>
                <ul className="dropdown-menu dropdown-submenu sombras">
                  <li
                    onClick={bloquear("Permisos Usuarios Presupuesto")}
                    style={{
                      pointerEvents:
                        accconfigpresu && accconfigpresu.substring(0, 1) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="/permisospresupuesto"
                      className={
                        accconfigpresu && accconfigpresu.substring(0, 1) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="fas fa-user-cog fa-fw me-1" />
                        Permisos Usuarios
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item ripple " href="#">
                  <i className="fas fa-print fa-fw me-1" />
                  Reportes »
                </a>
                <ul className="dropdown-menu sombras dropdown-submenu sombras">
                  <a
                    onClick={() => setMostrar6(true)}
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple "
                    type="button"
                    style={{
                      pointerEvents:
                        permisos && permisos.substring(7, 8) === "0"
                          ? "none"
                          : "cursor",
                      color:
                        permisos && permisos.substring(7, 8) === "0"
                          ? "rgba(144, 143, 142, 0.76)"
                          : "#1d0345",
                      backgroundColor:
                        permisos && permisos.substring(7, 8) === "0"
                          ? "transparent"
                          : "transparent",
                    }}
                  >
                    <span>
                      <i className="far fa-file-pdf fa-fw me-1" />
                      Resumen de Caja
                    </span>
                  </a>
                  <li
                    style={{
                      pointerEvents:
                        accpdfpresu && accpdfpresu.substring(1, 2) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfpresu && accpdfpresu.substring(1, 2) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Transacciones Diarias
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdfpresu && accpdfpresu.substring(2, 3) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfpresu && accpdfpresu.substring(2, 3) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Resumen de Caja por Banco
                      </span>
                    </Link>
                  </li>
                  <li
                    style={{
                      pointerEvents:
                        accpdfpresu && accpdfpresu.substring(3, 4) === "0"
                          ? "none"
                          : "cursor",
                    }}
                  >
                    <Link
                      to="#"
                      className={
                        accpdfpresu && accpdfpresu.substring(3, 4) === "0"
                          ? "dropdown-item ripple color"
                          : "dropdown-item ripple "
                      }
                    >
                      <span>
                        <i className="far fa-file-pdf fa-fw me-1" />
                        Transacciones Reversadas
                      </span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <a
            onClick={verConfig}
            className="btn-primary  list-group-item list-group-item-action py-2 ripple "
            type="button"
            style={{
              pointerEvents:
                permisos && permisos.substring(7, 8) === "0"
                  ? "none"
                  : "cursor",
              color:
                permisos && permisos.substring(7, 8) === "0"
                  ? "rgba(144, 143, 142, 0.76)"
                  : "#1d0345",
              backgroundColor:
                permisos && permisos.substring(7, 8) === "0"
                  ? "transparent"
                  : "transparent",
            }}
          >
            <i className="fas fa-cogs fa-fw me-3" />
            <span className=" fw-bold">Configuración</span>
          </a>

          <div onClick={logout}>
            <Link
              to="/"
              className="btn-primary list-group-item list-group-item-action py-2 ripple bg-transparent second-text "
            >
              <i className="fas fa-power-off fa-fw me-3 text-danger" />{" "}
              <span className="text-danger fw-bold">Salir</span>
            </Link>
            {/* <hr style={{ margin: 0, padding: 0, height: 0 }} /> */}
          </div>
          <br />
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <VerConfiguracion show={verConfiguracion} onHideCancela={verConfig} />
      <ConfigMina show={mostrar} onHideCancelar={modalConfigMina} />
      <ConfigProduccion show={mostrar1} onHideCancelar={modalConfigProduc} />

      <Config1x500 show={mostrar2} onHideCancelar={modalConfig1x500} />

      <CargarCatdesdeEfiscal
        show={mostrar3}
        operacion={operacion}
        onHideCancela={modalCargCat}
      />

      <CargarPucEfiscal
        show={mostrar4}
        operacion={operacionpu}
        onHideCancela={modalCargPuc}
      />

      <ReversarTransaccion
        show={mostrar5}
        operacion={operaciontrans}
        onHideCancela={modalReversarTransaccion}
      />

      <ReimprimirRecibo
        show={mostrar7}
        operacion={operaciontrans}
        onHideCancela={modalReimprimirRecibo}
      />

      <ResumenCaja
        show={mostrar6}
        titulo={tituloGestionIngresos}
        reporte={reporteGestionIngresos}
        onHideCancela={() => setMostrar6(false)}
      />

      <ReporteInspecciones
        show={mostrarInspecciones}
        onHide={() => setMostrarInspecciones(false)}
      />

      <ResumenRetenciones
        show={mostrar8}
        titulo={tituloGestionIngresos}
        reporte={reporteGestionIngresos}
        onHideCancela={() => setMostrar8(false)}
      />
      <ResumenDeclaracionMina
        show={mostrar9}
        onHideCancela={() => setMostrar9(false)}
      />
      <MinaxClasificador
        show={mostrar10}
        onHideCancela={() => setMostrar10(false)}
      />

      <ProduccionxClasificador
        show={mostrar11}
        onHideCancela={() => setMostrar11(false)}
      />

      <ImprimirTimbresporEntes
        show={mostrar13}
        onHideCancela={() => setMostrar13(false)}
      />

      <ResumenDeclaracionProduccion
        show={mostrar12}
        onHideCancela={() => setMostrar12(false)}
      />
    </div>
  );

  return sidebar;
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js